import React from 'react';
import { Popover, Button, Tooltip } from 'antd';
import PromptSvg from '@icons/prompt/prompt-ai-icon.svg';

export default function AIAlertColumnRenderer({
  rowData,
  alertsSessionAssociationValue,
  alertListValue,
}) {
  const curSessionId = rowData.SessionId;
  const impactedAlertIds = alertsSessionAssociationValue
    .filter((item) => {
      return item.impactedSessions.includes(curSessionId);
    })
    .map((item) => item.aiAlertId);

  const impactedAlertDataList: any = alertListValue.filter((alert) =>
    impactedAlertIds.includes(`${alert.alertId}`),
  );

  const alertLinkItems = impactedAlertDataList.map((alert, index) => {
    const { alertId, areAllRCDimensionsAvailable } = alert || {};
    const diagnosticsUrl = `${window.conviva.modules.EI.baseUrl}/dashboard/ai-alerts/pre-diagnostics/${alertId}`;

    return (
      <span key={alertId}>
        {areAllRCDimensionsAvailable ? (
          <a href={diagnosticsUrl} target="_blank" rel="noreferrer">
            {alertId}
          </a>
        ) : (
          <Tooltip title="Diagnostics are currently not supported for root-cause based on Custom Dimensions.">
            <span>{alertId}</span>
          </Tooltip>
        )}
        {index !== impactedAlertDataList.length - 1 ? ', ' : ''}
      </span>
    );
  });

  return impactedAlertDataList.length > 0 ? (
    <Popover
      content={
        <div>
          AI Alert ID:&nbsp;
          {alertLinkItems}
        </div>
      }
      placement="right"
    >
      <Button
        size="small"
        icon={<PromptSvg style={{ fontSize: '12px', marginRight: '4px' }} />}
        style={{ background: 'rgba(0, 0, 0, 0.02)' }}
      >
        AI
      </Button>
    </Popover>
  ) : (
    <Button
      size="small"
      icon={
        <PromptSvg style={{ fontSize: '12px', marginRight: '4px', color: 'rgba(0, 0, 0, 0.25)' }} />
      }
      disabled
    >
      AI
    </Button>
  );
}
